import { findBoilerAdapterBySlot, getHeatingCircuitByType } from 'z3k-parser/lib';
import { BoilerAdapter, HeatingCircuit } from 'z3k-config';
import { boiler_id_2_adapter_slot } from 'console/climatic/constants';
import { BoilerControlType } from 'console/climatic/setting-tabs/type';
import { getObjectLinks } from 'console/climatic/utils/getters';
import { guess_dhw_control_type } from 'console/climatic/utils/dhw-control-type';
import { guess_boiler_control_type, guess_heating_control_type, } from 'console/climatic/setting-tabs/configuration';
import { useContext } from 'react';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
export function useConfigurationState() {
    const { config } = useContext(Z3KSettingsEditor);
    const boilers = getHeatingCircuitByType(config, HeatingCircuit.Type.BOILER).map((circuit) => {
        const control_type = guess_boiler_control_type(config, circuit);
        const slot = boiler_id_2_adapter_slot(circuit.id);
        const boiler_adapter = slot != null ? findBoilerAdapterBySlot(config, slot) : null;
        return {
            id: circuit.id,
            name: circuit.name,
            control_type,
            has_adapter_on_slot: slot != null && boiler_adapter != null,
            show_unknown_option: control_type == BoilerControlType.UNKNOWN,
        };
    });
    const circuits = getHeatingCircuitByType(config, HeatingCircuit.Type.HEATING).map((circuit) => ({
        id: circuit.id,
        name: circuit.name,
        isIOExtensionCircuit: getObjectLinks(circuit.id, config?.object_arrays).length > 0,
        control_type: guess_heating_control_type(config, circuit),
    }));
    const dhw = getHeatingCircuitByType(config, HeatingCircuit.Type.DHW).map((circuit) => {
        const boiler_adapter = findBoilerAdapterBySlot(config, 1);
        return {
            id: circuit.id,
            name: circuit.name,
            control_type: guess_dhw_control_type(config, circuit),
            has_adapter_on_slot_1: boiler_adapter != null,
            boiler_second_channel: boiler_adapter != null
                ? BoilerAdapter.isSecondChannel(boiler_adapter)
                : false,
        };
    });
    const io_extensions = config.io_extensions ?? [];
    const blackList = [];
    const object_arrays = config.object_arrays ?? [];
    return { boilers, circuits, dhw, io_extensions, blackList, object_arrays };
}
